import { Dashboard } from "@/components/dashboard/Dashboard/Dashboard";
import { VStack } from "@/components/layout/VStack";
import { useEffect, useState } from "react";
import { useBrowseExplorations } from "../hooks/browseExplorations/useBrowseExplorations";
import { Skeleton } from "@/components/ui/Skeleton/Skeleton";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@/components/ui/Empty/Empty";
import { BookOpen } from "lucide-react";
import { BrowseExplorations } from "../components/browseExplorations/BrowseExplorations";

const StudentBrowseExplorations = () => {
  const [explorations, setExplorations] = useState<{
    explorations: any[];
    rotations: any[];
    sessions: any[];
    teachers: any[];
  }>({
    explorations: [],
    rotations: [],
    sessions: [],
    teachers: [],
  });

  const { loadExplorations, loading } = useBrowseExplorations();

  useEffect(() => {
    loadExplorations(setExplorations);
  }, []);

  return (
    <Dashboard activePage="/explorations">
      <VStack>
        <h2
          style={{
            fontSize: "var(--text-2xl)",
            lineHeight: "var(--line-height-2xl)",
            fontWeight: "var(--font-bold)",
          }}
        >
          Browse Explorations
        </h2>
        <p style={{ color: "var(--muted-foreground)" }}>
          View all explorations.
        </p>
      </VStack>
      {loading ? (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr 1fr",
            gap: "1rem",
          }}
        >
          {Array.from({ length: 6 }, (_, i) => (
            <Skeleton key={i} style={{ height: "240px", width: "100%" }} />
          ))}
        </div>
      ) : explorations.explorations.length < 1 ? (
        <Empty style={{ borderColor: "var(--secondary-border)" }}>
          <EmptyHeader>
            <EmptyMedia variant="icon">
              <BookOpen />
            </EmptyMedia>
            <EmptyTitle>No Explorations Found</EmptyTitle>
            <EmptyDescription>
              There were no explorations found for students to view. If you
              believe this is an error, please refresh.
            </EmptyDescription>
          </EmptyHeader>
        </Empty>
      ) : (
        <BrowseExplorations data={explorations} />
      )}
    </Dashboard>
  );
};

export default StudentBrowseExplorations;
